if(window.location.href.indexOf("update-stage-thank-you") > -1){
  $(document).on("swell:setup", function() {
    $.ajax({
      type: 'POST',
      url: "https://app.swellrewards.com/api/v2/actions",
      data: {
        'type' : 'CustomAction',
        'customer_email' : spapi.customer.email,
        'action_name' : 'update stage',
        'merchant_id' : '51294',
        'api_key' : 'sHiEjbw9mZoE0cwTFZvQ6Att',
      }
    });
  });
}